export default {
  signature: {
    qa: 'Quality Control',
    lab: 'Lab',
  },
  errors: {
    downloadPdfFailed: 'Failed to download the Quality report for {report}. If that error continues to persist please get in contact with the Qmulus Support.',
  },
};
